// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCdt-6TjKeognPTTqvkIhMBsI_6OZnHSx4",
  authDomain: "fuel-82d3e.firebaseapp.com",
  projectId: "fuel-82d3e",
  storageBucket: "fuel-82d3e.firebasestorage.app",
  messagingSenderId: "1089003212232",
  appId: "1:1089003212232:web:8661399ccc4540794b04fd",
  measurementId: "G-Z2S5M4849J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };